<script>
  import { goto } from "$app/navigation";
  import { pages } from "./RecommendedPages";
  import { parsePrice } from "$lib/utils/parsePrice";
  import ShoppingBagItem from "../cart/ShoppingBagItem.svelte";

  export let shoppingBag;
  export let totals;
  export let isOpenModal = false;
</script>

<div class="shopping-bag-content">
  <button class="close" on:click={() => (isOpenModal = false)}>
    <img src="/images/svg/close.svg" alt="close button" />
  </button>
  <h3>Shopping Bag</h3>
  {#if shoppingBag && shoppingBag.items.length > 0}
    <ul class="shopping-items">
      {#each shoppingBag?.items as item}
        <ShoppingBagItem {item} isMini={true} />
      {/each}
    </ul>
  {:else}
    <div class="container-empty">
      <div class="content-top">
        <p class="msg-empty">
          <b> Your bag is empty!<br /> </b>
          Add products to bag, and get great offers!
        </p>
        <button on:click={() => (isOpenModal = false)} class="btn-action-url">
          <span>CONTINUE SHOPPING</span>
        </button>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 683 3">
        <line x2="683" transform="translate(0 1.5)" stroke="#ff9438" stroke-width="3" />
      </svg>
      <div class="you-may-like">
        <h4>Products you may like</h4>
        <ul class="list-pages">
          {#each pages as page}
            <a href={page.link} on:click={() => (isOpenModal = false)}>
              <li class="card">
                <picture>
                  <source
                    srcset={`${page.images.x1} 1x, ${page.images.x2} 2x,${page.images.x3} 3x,`}
                  />
                  <img src={page.images.x1} alt={page.name} />
                </picture>
                <p>{page.name}</p>
              </li>
            </a>
          {/each}
        </ul>
      </div>
    </div>
  {/if}
  {#if totals}
    <div class="totals">
      <div class="estimated">
        <p>Estimated Total</p>
        <p class="subtotal">{parsePrice("GBP", "en-gb", totals.grand_total)}</p>
      </div>
      <button
        class="btn-action-url"
        on:click={() => {
          goto("/cart");
          isOpenModal = false;
        }}
      >
        <span>GO TO BAG</span>
      </button>
    </div>
  {/if}
</div>

<style>
  a {
    text-decoration: none;
    color: inherit;
  }
  .shopping-bag-content {
    position: absolute;
    right: -30px;
    top: -15px;
    background-color: white;
    border: 3px solid var(--orange);
    border-radius: 3rem;
    overflow: hidden;
    transition: all 0.5s ease;
    animation: popShoppingBag 500ms ease forwards;
    z-index: 50;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 90svw;
    max-width: 620px;
    aspect-ratio: 4/5.5;
  }
  .shopping-bag-content h3 {
    font-size: 5.3rem;
    font-family: var(--genty);
    letter-spacing: 0px;
    color: var(--orange);
    text-transform: capitalize;
    text-align: center;
    line-height: 1.5;
    margin-bottom: 20px;
    font-weight: 400;
  }
  .close {
    width: 45px;
    height: 45px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    align-self: flex-end;
    margin: 10px 10px 0 0;
  }
  .shopping-items {
    overflow-y: scroll;
    width: 95%;
  }
  .container-empty {
    display: grid;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    grid-template-rows: 3fr 1fr 8fr;
  }
  .content-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
  .totals {
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto auto 40px auto;
  }
  .msg-empty {
    width: 100%;
    text-align: center;
    font-size: 2.8rem;
    line-height: 1;
  }
  .msg-empty b {
    font-size: 3.5rem;
    font-family: sirenia;
  }
  svg {
    width: 90%;
    margin: 0 auto;
    height: 3px;
  }
  .estimated {
    width: 95%;
    display: flex;
    justify-content: space-between;
    font-size: 4rem;
    color: var(--pink);
    font-family: sirenia;
    margin: 0 auto;
    padding: 42px 0 30px 0;
    background-color: transparent;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
  .btn-action-url {
    background-color: var(--global);
    box-shadow:
      0 0 40px 40px var(--global) inset,
      0 0 0 0 var(--global);
  }
  .btn-action-url span {
    color: var(--white);
  }
  .btn-action-url:hover {
    background: var(--white);
    box-shadow:
      0 0 0px 0 var(--global) inset,
      0 0 0px 4px var(--global);
  }
  .btn-action-url:hover span {
    color: var(--global);
  }
  .you-may-like {
    overflow: hidden;
    width: 100%;
  }
  .you-may-like h4 {
    font-size: 3.8rem;
    text-align: center;
    margin-bottom: 35px;
  }
  .list-pages {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 228px;
    overflow-x: scroll;
    margin: 0 0 0 30px;
    gap: 10px;
    justify-self: flex-start;
    padding: 0 60px 60px 0;
  }
  .card {
    aspect-ratio: 4/5;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: sirenia;
    font-size: 2.2rem;
  }
  .card img {
    object-fit: cover;
    border-radius: 30px;
  }
  .subtotal {
    font-size: 4.4rem;
    color: var(--orange);
    font-weight: 700;
  }

  @keyframes popShoppingBag {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    45% {
      transform: scale(1.05);
      opacity: 1;
    }
    80% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
